import { useMeeting } from '@/context/meeting-context';
import dayjs from 'dayjs';
import StudentHistory from '@/components/student-history';

const CoachActiveMeeting = () => {
	const { socketData } = useMeeting();
	const { handleMatch, meetingCreated, connectionData } = socketData;

	return (
		<div className={'coach-mockup-container'}>
			<div className={'coach-mockup-container-student'}>
				<p className={'title'}>Aktif Görüşme</p>
				<div className={'coach-mockup-container-student-info'}>
					<div className={'coach-mockup-container-student-info-container'}>
						<img
							src={connectionData?.userInfos?.studentAvatar}
							alt={connectionData?.userInfos?.studentName}
						/>
						<div>
							<p className={'user-full-name'}>
								{connectionData?.userInfos?.studentName} {connectionData?.userInfos?.studentSurname}
							</p>
							<span className={'meeting-date'}>{dayjs(meetingCreated?.startDate).format('D MMMM, HH:mm')}</span>
						</div>
					</div>
					<div className={'coach-mockup-container-meeting-subject'}>
						<span>{handleMatch?.meetingSubject?.subjectName || connectionData?.meetingSubjectName}</span>
					</div>
				</div>
			</div>
			<StudentHistory
				studentId={handleMatch?.studentId || connectionData?.userInfos?.studentId}
				gradeId={handleMatch?.gradeId || connectionData?.userInfos?.gradeId}
			/>
		</div>
	);
};

export default CoachActiveMeeting;
